<template>
  <div class="cognito-logo-mark" aria-label="SlashExperts">
    <span class="cognito-logo-mark__slash" aria-hidden="true">/</span>
    <span class="cognito-logo-mark__word">Experts</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CognitoLogoMark",
});
</script>

<style scoped>
.cognito-logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  min-height: 60px;
  max-width: 240px;
  width: auto;
  border: none;
  color-scheme: light;
  text-align: center;
  /* Do not clip: overflow + tight line-height caused the wordmark to disappear */
  user-select: none;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.cognito-logo-mark__slash {
  color: #6a48f3;
  font-weight: 700;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  line-height: 1.1;
}

.cognito-logo-mark__word {
  color: #1f2937;
  font-weight: 700;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  line-height: 1.1;
  letter-spacing: -0.02em;
}
</style>
